import { axiosInstance } from '@/lib/axios';
import { GpsAndBorderCrossingConfigurationModel } from './types';

type Props = {
  companyId: string
}

export function getGpsSettings({ companyId }: Props) {
  return axiosInstance.get<GpsAndBorderCrossingConfigurationModel>(`/api/${companyId}/configuration/gps`);
}
